import { Box, Typography, TypographyVariant } from '@mui/material'
import CustomerIcon from '@mui/icons-material/PermContactCalendar'

import { printCustomerName } from 'components/CustomerAdmin/utils'
import { CustomerLookupContract } from 'models'

interface PrintSelectCustomerProps {
    selectCustomer?: CustomerLookupContract
    variant?: TypographyVariant
    loading?: boolean
}
function PrintSelectCustomer({
    selectCustomer,
    variant = 'body1',
    loading = false,
}: PrintSelectCustomerProps) {
    return (
        <Box alignItems="center" display="flex">
            <Box>
                <CustomerIcon />
            </Box>
            <Box paddingLeft={1}>
                <Typography component={'span'} variant={variant}>
                    {selectCustomer
                        ? printCustomerName(selectCustomer)
                        : loading
                        ? 'Loading...'
                        : '-'}
                </Typography>
            </Box>
        </Box>
    )
}

export default PrintSelectCustomer
